
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { extractMessageFromException, getMauticContactId } from '@/utils/helpers'
import analytics from '~/mixins.js/analytics'
import '@/utils/initValidationRules'

export default {
  components: { ValidationProvider, ValidationObserver },
  mixins: [analytics],
  data () {
    return {
      customerName: null,
      loading: false,
      email: null,
      message: null,
      termsAndNewsletterAgreement: false,
      zohoCampaignId: null,
      newsletterRequired: true,
      sent: false,
      freeProduct: null,
      name: 'newsletter'
    }
  },
  methods: {
    async submitForm () {
      this.loading = true
      this.freeSampleDiagram = await this.$backend.diagrams.get({ name: 'free_sample' }).then(d => d.results[0])
      try {
        await this.$backend.freeProduct.post({
          email: this.email,
          diagram_id: this.freeSampleDiagram.id,
          message: this.message,
          newsletter_agreement: this.termsAndNewsletterAgreement,
          terms_agreement: this.termsAndNewsletterAgreement,
          mautic_contact_id: getMauticContactId(),
          first_name: this.customerName
        })
        this.trackEvent('Lead', 'Newsletter page')
        this.trackEvent('Lead', this.message)
        this.$bing && this.$bing.event(
          {
            event_category: 'Lead'
          },
          'submit_lead_form'
        )
        this.$emit('submit')
        this.sent = true
      } catch (error) {
        console.log('Error', error)
        this.$toast.error(extractMessageFromException(error))
      } finally {
        this.loading = false
      }
    }
  }
}
